import { render, staticRenderFns } from "./Blade2b.vue?vue&type=template&id=f3f9ff9a"
import script from "./Blade2b.vue?vue&type=script&lang=js"
export * from "./Blade2b.vue?vue&type=script&lang=js"
import style0 from "./Blade2b.vue?vue&type=style&index=0&id=f3f9ff9a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports